import { variables } from "./variables.js";
import { myIdea, myIdeasList } from "./myIdeas.js";
import { othersIdea,othersIdeaList } from "./ideasOthers.js";
import { userNominated,userNominatedList } from "./userNomination.js";
import apis from "../assets/js/apis.js";
import EventEmitter from '../events.js';
import { useContext, createContext } from "react";
import { types, onPatch } from "mobx-state-tree";
import axios from 'axios';

const APPLY_WHEN_SENDING_TO_WEBSITE = 1;
const APPLY_WHEN_SENDING_TO_COLLEGE_SCREEN = 2;
const APPLY_WHEN_USER_UNNOMINATED_BUT_COLLEGE_SELECTED = 3;
const APPLY_WHEN_SENDING_HOME = 4;
const APPLY_WHEN_SENDING_TO_NOMINATIONS_PAGE = 5;
const APPLY_WHEN_SENDING_TO_IDEA_COLLECTION = 6;
const APPLY_WHEN_YOU_NEED_MORE_IDEAS_OF_OTHERS = 7;
const APPLY_WHEN_YOU_NEED_MORE_OF_YOUR_IDEAS = 8;
const APPLY_WHEN_YOU_NEED_MORE_UNNOMINATED_PEOPLE = 9;

const NO_USERNAME_OR_PASSWORD = 56;
const USERNAME_AND_PASSWORD = 57;

const RootModel = types.model({
    variables: variables,
    myIdeas: myIdeasList,
    othersIdeas: othersIdeaList,
    unnominated: userNominatedList,
  }).actions(self=>({
        restore_variables(data){
            self.variables._restore(data);
        }
  }))

let initialState = RootModel.create({
    variables: {},
    myIdeas: {
        ideas: []
    },
    othersIdeas: {
        ideas: []
    },
    unnominated: {
        users: []
    },
  });

const data = localStorage.getItem('variablesSaved');
console.log(data);
if (data) {
  const json = JSON.parse(data);
  if (variables.is(json)) {
    initialState.restore_variables(json);
    if(initialState.variables.username&&initialState.variables.password){
      setTimeout(()=>{
        EventEmitter.dispatch('startProcess',{
          event: USERNAME_AND_PASSWORD,
          username: initialState.variables.username,
          password: initialState.variables.password,
        })
      },500)
    }
  }
}
else {
  console.log(3);
  setTimeout(()=>{
    EventEmitter.dispatch('startProcess',{
      event: NO_USERNAME_OR_PASSWORD,
    })
  },500)
}

export const rootStore = initialState;

export const RootStoreContext = createContext(null);

export const Provider = RootStoreContext.Provider;
export function useMst() {
    const store = useContext(RootStoreContext);
    if (store === null) {
      throw new Error("Store cannot be null, please add a context provider");
    }
    return store;
}

onPatch(rootStore, patch => {
  const options = {
    headers: {'Authorization': `Bearer ${rootStore.variables.access_token}`}
  };
  if(patch.path=="/variables/e"){
    if(rootStore.variables.e==APPLY_WHEN_SENDING_TO_COLLEGE_SCREEN){
      
      axios.get(apis.getcolleges,options)
        // fetch(colleges)
        // error(if server no response - show server_down)
        // error(if client error - reload)
        // message(when last cases like 0 data)
    }
    else if(rootStore.variables.e==APPLY_WHEN_USER_UNNOMINATED_BUT_COLLEGE_SELECTED){
        if(rootStore.unnominated.numberOfUnnominatedChildren()<10){
        axios.post(apis.sendunnominated,{"college_id":rootStore.variables.college_id},options).
        then(response=>{
          let a= []
          response.data.un_noms.forEach(element=>{
              a.append(userNominated.create({
                name: element["name"],
                email: element["email"],
                image: element["pic_url"],
                id: element["id"],
              }));})
              rootStore.unnominated.addUsersNominated(a);
          
        },error=>{;})}
    }
    else if(rootStore.variables.e==APPLY_WHEN_SENDING_HOME){
        //fetch(ideas==ifAllseen,ownideas==ifempty,nominations==ifempty)
        if(rootStore.othersIdeas.numberOfUnseenChildren()<4){
        axios.get(apis.sendideas,options).
        then(response=>{
          let a= []
          response.data.ideas.forEach(element=>{
              a.append(othersIdea.create({
                text: element["text"],
                id: element["id"],
              }));})
              rootStore.othersIdeas.addOthersIdeas(a);
          
          return axios.post(apis.sendmyideas,{"page":rootStore.variables.page},options)
        },error=>{;}).then(response=>{
          if(rootStore.myIdeas.numberOfChildren()<10&&response.data.ideas.length>0)
          {
          let b= []
          response.data.ideas.forEach(element=>{
              b.append(myIdea.create({
                text: element["text"],
                id: element["id"],
                date: element["created_at"],
              }));})
              rootStore.myIdeas.addMyIdeas(b);
          
          return axios.post(apis.sendunnominated,{"college_id":rootStore.variables.college_id},options)
        }}).then(response=>{
          if(rootStore.unnominated.numberOfUnnominatedChildren()<10&&response.data.un_noms.length>0){
          let c= []
          response.data.un_noms.forEach(element=>{
              c.append(userNominated.create({
                name: element["name"],
                email: element["email"],
                image: element["pic_url"],
                id: element["id"],
              }));
            })
              rootStore.unnominated.addUsersNominated(c);
        }},error=>{;})
      }
    }
    else if(rootStore.variables.e==APPLY_WHEN_SENDING_TO_NOMINATIONS_PAGE){
      if(rootStore.unnominated.numberOfUnnominatedChildren()<10)
      axios.post(apis.sendunnominated,{"college_id":rootStore.variables.college_id},options).
        then(response=>{
          if(response.data.un_noms.length>0){
          let a= []
          response.data.un_noms.forEach(element=>{
              a.append(userNominated.create({
                name: element["name"],
                email: element["email"],
                image: element["pic_url"],
                id: element["id"],
              }));})
          rootStore.unnominated.addUsersNominated(a);
            }
        },error=>{;})
    }
    else if(rootStore.variables.e==APPLY_WHEN_SENDING_TO_IDEA_COLLECTION){
      if(rootStore.myIdeas.numberOfChildren()<10)
      axios.post(apis.sendmyideas,{"page":rootStore.variables.page},options)
      .then(response=>{
        if(response.data.ideas.length>0){
          let b= []
          response.data.ideas.forEach(element=>{
              b.append(myIdea.create({
                text: element["text"],
                id: element["id"],
                date: element["created_at"],
              }));})
              rootStore.myIdeas.addMyIdeas(b);}},error=>{;})

    }
    else if(rootStore.variables.e==APPLY_WHEN_YOU_NEED_MORE_IDEAS_OF_OTHERS){
      axios.get(apis.sendideas,options).
        then(response=>{
          if(response.data.ideas.length>0){
          let a= []
          response.data.ideas.forEach(element=>{
              a.append(othersIdea.create({
                text: element["text"],
                id: element["id"],
              }));})
              rootStore.othersIdeas.addOthersIdeas(a);
          }
        },error=>{;})
    }
    else if(rootStore.variables.e==APPLY_WHEN_YOU_NEED_MORE_OF_YOUR_IDEAS){
      
    }
    else if(rootStore.variables.e==APPLY_WHEN_YOU_NEED_MORE_UNNOMINATED_PEOPLE){
      axios.post(apis.sendunnominated,{"college_id":rootStore.variables.college_id},options).
        then(response=>{
          if(response.data.un_noms.length>0){
          let a= []
          response.data.un_noms.forEach(element=>{
              a.append(userNominated.create({
                name: element["name"],
                email: element["email"],
                image: element["pic_url"],
                id: element["id"],
              }));})
          rootStore.unnominated.addUsersNominated(a);
          }
        },error=>{;})
    }
  }
});